/*
 * @Author: Yun
 * @Date: 2023-12-08 22:58:51
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-28 09:14:42
 */

import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import './index.less'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper/core'

import 'swiper/swiper.min.css'
import 'swiper/swiper.scss'
import 'swiper/components/pagination/pagination.scss'
SwiperCore.use([Autoplay, Pagination, Navigation])

const FourthPage = (props) => {
    const [pageIndex, setPageIndex] = useState(1)
    const clickEs = () => {
        setPageIndex(1)
    }

    const clickFr = () => {
        setPageIndex(2)
    }

    const clickAr = () => {
        setPageIndex(3)
    }

    const clickRu = () => {
        setPageIndex(4)
    }
    return (
        <div className="fourth-page">
            <div className="country-banner-wrapper">
                {pageIndex == 1 ? (
                    <div
                        className="country-banner-item-active"
                        onClick={() => {
                            clickEs()
                        }}
                    >
                        Español
                    </div>
                ) : (
                    <div
                        className="country-banner-item"
                        onClick={() => {
                            clickEs()
                        }}
                    >
                        Español
                    </div>
                )}

                {pageIndex == 2 ? (
                    <div
                        className="country-banner-item-active"
                        onClick={() => {
                            clickFr()
                        }}
                    >
                        Français
                    </div>
                ) : (
                    <div
                        className="country-banner-item"
                        onClick={() => {
                            clickFr()
                        }}
                    >
                        Français
                    </div>
                )}

                {pageIndex == 3 ? (
                    <div
                        className="country-banner-item-active"
                        onClick={() => {
                            clickAr()
                        }}
                    >
                        العربية
                    </div>
                ) : (
                    <div
                        className="country-banner-item"
                        onClick={() => {
                            clickAr()
                        }}
                    >
                        العربية
                    </div>
                )}

                {pageIndex == 4 ? (
                    <div
                        className="country-banner-item-active"
                        onClick={() => {
                            clickRu()
                        }}
                    >
                        Русский
                    </div>
                ) : (
                    <div
                        className="country-banner-item"
                        onClick={() => {
                            clickRu()
                        }}
                    >
                        Русский
                    </div>
                )}
            </div>
            {pageIndex == 1 && (
                <div className="fourth-page-main">
                    <div className="title-wrapper">
                        {/* <div className="title">Español</div> */}

                        <div className="title-content">
                            <a href="https://espanol.cgtn.com/portada" target="_blank">
                                <div className="title-content-icon"></div>
                                <div className="title-content-item">Read more</div>
                            </a>
                        </div>
                    </div>
                    <div className="news-wrapper">
                        <div className="news-content-left">
                            <a
                                href="https://espanol.cgtn.com/news/2024-11-16/1857695045515575297/"
                                target="_blank"
                            >
                                <div className="news-content-left-img es-1"></div>
                            </a>
                            <div className="news-content-left-content-wrapper">
                                <div className="news-content-left-title">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-11-16/1857695045515575297/"
                                        target="_blank"
                                    >
                                        Ecos del Desarrollo: A través de los pasos
                                    </a>
                                </div>
                                <div className="news-content-left-content">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-11-16/1857695045515575297/"
                                        target="_blank"
                                    >
                                        En este episodio de la serie Ecos del Desarrollo, acudimos
                                        al Museo de Aduanas de China, desde donde iniciamos un viaje
                                        retrospectivo para conocer el desarrollo del país a través
                                        de sus pasos comerciales.
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="news-content-right">
                            <div className="news-content-top">
                                <div className="news-content-top-item-1">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-10-30/1851453587592437761/"
                                        target="_blank"
                                    >
                                        <div className="top-item-1-img es-2"></div>
                                    </a>
                                    <div className="top-item-1-content">
                                        <a
                                            href="https://espanol.cgtn.com/news/2024-10-30/1851453587592437761/"
                                            target="_blank"
                                        >
                                            Ecos del Desarrollo: Testigos de la diplomacia
                                        </a>
                                    </div>
                                </div>
                                <div className="news-content-top-item-2">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-01-09/1744608494284484609/index.html"
                                        target="_blank"
                                    >
                                        <div className="top-item-2-img es-3"></div>
                                    </a>
                                    <div className="top-item-2-content">
                                        <a
                                            href="https://espanol.cgtn.com/news/2024-01-09/1744608494284484609/index.html"
                                            target="_blank"
                                        >
                                            Una senda propia: Más allá de lo material
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="news-content-bottom">
                                <div className="news-content-bottom-item-1">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-01-30/1752194843579346945/index.html"
                                        target="_blank"
                                    >
                                        <div className="bottom-item-1-img es-4"></div>
                                    </a>
                                    <div className="bottom-item-1-content">
                                        <a
                                            href="https://espanol.cgtn.com/news/2024-01-30/1752194843579346945/index.html"
                                            target="_blank"
                                        >
                                            Una senda propia: Un rumbo sostenible
                                        </a>
                                    </div>
                                </div>
                                <div className="news-content-bottom-item-2">
                                    <a
                                        href="https://espanol.cgtn.com/news/2024-02-11/1756499652922929154/"
                                        target="_blank"
                                    >
                                        <div className="bottom-item-2-img es-5"></div>
                                    </a>
                                    <div className="bottom-item-2-content">
                                        <a
                                            href="https://espanol.cgtn.com/news/2024-02-11/1756499652922929154/"
                                            target="_blank"
                                        >
                                            Una senda propia: La brújula del desarrollo pacífico
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pageIndex == 2 && (
                <div className="fourth-page-main">
                    <div className="title-wrapper">
                        {/* <div className="title">Français</div> */}

                        <div className="title-content">
                            <a href="https://francais.cgtn.com/home" target="_blank">
                                <div className="title-content-icon"></div>
                                <div className="title-content-item">Read more</div>
                            </a>
                        </div>
                    </div>
                    <div className="news-wrapper">
                        <div className="news-content-left">
                            <a
                                href="https://francais.cgtn.com/news/2024-09-05/1831540398552977410/index.html"
                                target="_blank"
                            >
                                <div className="news-content-left-img fr-1"></div>
                            </a>
                            <div className="news-content-left-content-wrapper">
                                <div className="news-content-left-title">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-09-05/1831540398552977410/index.html"
                                        target="_blank"
                                    >
                                        Lettre de réponse : les groupes de réflexion dans les
                                        relations internationales
                                    </a>
                                </div>
                                <div className="news-content-left-content">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-09-05/1831540398552977410/index.html"
                                        target="_blank"
                                    >
                                        Le Président chinois Xi Jinping a répondu aux chercheurs de
                                        50 pays africains, les encourageant à continuer à fournir un
                                        soutien intellectuel pour la construction...
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="news-content-right">
                            <div className="news-content-top">
                                <div className="news-content-top-item-1">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-11-08/1854774859656343553/index.html"
                                        target="_blank"
                                    >
                                        <div className="top-item-1-img fr-2"></div>
                                    </a>
                                    <div className="top-item-1-content">
                                        <a
                                            href="https://francais.cgtn.com/news/2024-11-08/1854774859656343553/index.html"
                                            target="_blank"
                                        >
                                            Lettre de réponse : Que l'essence de toutes les
                                            civilisations soit...
                                        </a>
                                    </div>
                                </div>
                                <div className="news-content-top-item-2">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-08-30/1829465609308745729/index.html"
                                        target="_blank"
                                    >
                                        <div className="top-item-2-img fr-3"></div>
                                    </a>
                                    <div className="top-item-2-content">
                                        <a
                                            href="https://francais.cgtn.com/news/2024-08-30/1829465609308745729/index.html"
                                            target="_blank"
                                        >
                                            Lettre de réponse : la « Route du bonheur » de « la
                                            Ceinture et la...
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="news-content-bottom">
                                <div className="news-content-bottom-item-1">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-09-01/1830167940134539265/index.html"
                                        target="_blank"
                                    >
                                        <div className="bottom-item-1-img fr-4"></div>
                                    </a>
                                    <div className="bottom-item-1-content">
                                        <a
                                            href="https://francais.cgtn.com/news/2024-09-01/1830167940134539265/index.html"
                                            target="_blank"
                                        >
                                            LETTRE DE RÉPONSE : Maîtriser l'histoire et la culture
                                            chinoises...
                                        </a>
                                    </div>
                                </div>
                                <div className="news-content-bottom-item-2">
                                    <a
                                        href="https://francais.cgtn.com/news/2024-09-03/1830872546818666498/index.html"
                                        target="_blank"
                                    >
                                        <div className="bottom-item-2-img fr-5"></div>
                                    </a>
                                    <div className="bottom-item-2-content">
                                        <a
                                            href="https://francais.cgtn.com/news/2024-09-03/1830872546818666498/index.html"
                                            target="_blank"
                                        >
                                            Lettre de réponse : comprendre les spécificités de la
                                            Chine et étudier...
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pageIndex == 3 && (
                <div className="fourth-page-main">
                    <div className="title-wrapper">
                        {/* <div className="title rtl">العربية</div> */}
                        <div className="title-content">
                            <a href="https://arabic.cgtn.com/home" target="_blank">
                                <div className="title-content-icon"></div>
                                <div className="title-content-item">Read more</div>
                            </a>
                        </div>
                    </div>
                    <div className="news-wrapper">
                        <div className="news-content-left">
                            <a
                                href="https://arabic.cgtn.com/news/2024-05-26/1794448418009292801/index.html"
                                target="_blank"
                            >
                                <div className="news-content-left-img ar-1"></div>
                            </a>
                            <div className="news-content-left-content-wrapper">
                                <div className="news-content-left-title rtl">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-05-26/1794448418009292801/index.html"
                                        target="_blank"
                                    >
                                        جسور المحبة: المهارة.. منارة تنير الشباب
                                    </a>
                                </div>
                                <div className="news-content-left-content rtl">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-05-26/1794448418009292801/index.html"
                                        target="_blank"
                                    >
                                        "المعارف والأعمال تعتمدان على بعضهما البعض في أداء
                                        وظائفهما". في هذه الحلقة من "جسور المحبة"، نستكشف مع ضيوفنا
                                        كيف يمكن لتعليم المهارات المهنية تمكين الشباب الصيني والمصري
                                        من أن يصبحوا صانعي أحلام ويساهموا في تنمية العلاقات
                                        الثنائية.
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="news-content-right">
                            <div className="news-content-top">
                                <div className="news-content-top-item-1">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-05-26/1794448661381627905/index.html"
                                        target="_blank"
                                    >
                                        <div className="top-item-1-img ar-2"></div>
                                    </a>
                                    <div className="top-item-1-content rtl">
                                        <a
                                            href="https://arabic.cgtn.com/news/2024-05-26/1794448661381627905/index.html"
                                            target="_blank"
                                        >
                                            جسور المحبة: الري الذكي.. تبشير بالحصاد
                                        </a>
                                    </div>
                                </div>
                                <div className="news-content-top-item-2">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-06-14/1801397008659103746/index.html"
                                        target="_blank"
                                    >
                                        <div className="top-item-2-img ar-3"></div>
                                    </a>
                                    <div className="top-item-2-content rtl">
                                        <a
                                            href="https://arabic.cgtn.com/news/2024-06-14/1801397008659103746/index.html"
                                            target="_blank"
                                        >
                                            جسور المحبة: رحلتي إلى الشرق
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="news-content-bottom">
                                <div className="news-content-bottom-item-1">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-05-28/1794449597776773122/index.html"
                                        target="_blank"
                                    >
                                        <div className="bottom-item-1-img ar-4"></div>
                                    </a>
                                    <div className="bottom-item-1-content rtl">
                                        <a
                                            href="https://arabic.cgtn.com/news/2024-05-28/1794449597776773122/index.html"
                                            target="_blank"
                                        >
                                            جسور المحبة: الأصفر والأخضر.. من المواجهة إلى التعايش
                                        </a>
                                    </div>
                                </div>
                                <div className="news-content-bottom-item-2">
                                    <a
                                        href="https://arabic.cgtn.com/news/2024-05-29/1794449858549235714/index.html"
                                        target="_blank"
                                    >
                                        <div className="bottom-item-2-img ar-5"></div>
                                    </a>
                                    <div className="bottom-item-2-content rtl">
                                        <a
                                            href="https://arabic.cgtn.com/news/2024-05-29/1794449858549235714/index.html"
                                            target="_blank"
                                        >
                                            جسور المحبة: مدينة المستقبل
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pageIndex == 4 && (
                <div className="fourth-page-main">
                    <div className="title-wrapper">
                        {/* <div className="title">Русский</div> */}
                        <div className="title-content">
                            <a href="https://russian.cgtn.com/home" target="_blank">
                                <div className="title-content-icon"></div>
                                <div className="title-content-item">Read more</div>
                            </a>
                        </div>
                    </div>
                    <div className="news-wrapper">
                        <div className="news-content-left">
                            <a
                                href="https://russian.cgtn.com/news/2024-12-06/1864861031838457858/index.html"
                                target="_blank"
                            >
                                <div className="news-content-left-img ru-1"></div>
                            </a>
                            <div className="news-content-left-content-wrapper">
                                <div className="news-content-left-title">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864861031838457858/index.html"
                                        target="_blank"
                                    >
                                        Андрей Денисов рассказал о влиянии Китая на мир
                                    </a>
                                </div>
                                <div className="news-content-left-content">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864861031838457858/index.html"
                                        target="_blank"
                                    >
                                        По случаю 75-летия установления дипломатических отношений
                                        между Китаем и Россией CGTN запустил масштабное
                                        телевизионное шоу "Идеи меняют". В рамках...
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="news-content-right">
                            <div className="news-content-top">
                                <div className="news-content-top-item-1">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864862163264544770/index.html"
                                        target="_blank"
                                    >
                                        <div className="top-item-1-img ru-2"></div>
                                    </a>
                                    <div className="top-item-1-content">
                                        <a
                                            href="https://russian.cgtn.com/news/2024-12-06/1864862163264544770/index.html"
                                            target="_blank"
                                        >
                                            Зампредседателя ЦК КПРФ: государственный строй...
                                        </a>
                                    </div>
                                </div>
                                <div className="news-content-top-item-2">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864863391264481281/index.html"
                                        target="_blank"
                                    >
                                        <div className="top-item-2-img ru-3"></div>
                                    </a>
                                    <div className="top-item-2-content">
                                        <a
                                            href="https://russian.cgtn.com/news/2024-12-06/1864863391264481281/index.html"
                                            target="_blank"
                                        >
                                            Эксперт рассказал о китайском пути "зеленого развития"
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="news-content-bottom">
                                <div className="news-content-bottom-item-1">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864864027925192706/index.html"
                                        target="_blank"
                                    >
                                        <div className="bottom-item-1-img ru-4"></div>
                                    </a>
                                    <div className="bottom-item-1-content">
                                        <a
                                            href="https://russian.cgtn.com/news/2024-12-06/1864864027925192706/index.html"
                                            target="_blank"
                                        >
                                            Эксперт: и в древности, и сейчас китайская культура
                                            всегда...
                                        </a>
                                    </div>
                                </div>
                                <div className="news-content-bottom-item-2">
                                    <a
                                        href="https://russian.cgtn.com/news/2024-12-06/1864864862562328577/index.html"
                                        target="_blank"
                                    >
                                        <div className="bottom-item-2-img ru-5"></div>
                                    </a>
                                    <div className="bottom-item-2-content">
                                        <a
                                            href="https://russian.cgtn.com/news/2024-12-06/1864864862562328577/index.html"
                                            target="_blank"
                                        >
                                            Эксперт: справедливое и гармоничное глобальное...
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default FourthPage
